import React, { ChangeEvent } from 'react';

import { i18n } from '../../helpers/i18n';
import TextArea from '../textarea';
import { REASONS, REASONS_GROUPS, Reason as ReasonType } from './constants';
import { Reason } from './reason';
import styles from './styles.css';

type Props = {
    message: string;
    checkedReasons: Set<ReasonType>;
    addReason: (reason: ReasonType) => void;
    deleteReason: (reason: ReasonType) => void;
    onMessageChange: ({ target: { value } }: ChangeEvent<HTMLTextAreaElement>) => void;
};

export function Content({ message, checkedReasons, addReason, deleteReason, onMessageChange }: Props) {
    return (
        <div className={styles.content}>
            {REASONS_GROUPS.map((group) => (
                <div className={styles.group} key={group}>
                    <div className={styles.groupTitle}>{i18n('feedback', `reason_group_${group}`)}</div>
                    <div className={styles.reasons}>
                        {REASONS[group].map((reason) => (
                            <Reason
                                reason={reason}
                                initialChecked={checkedReasons.has(reason)}
                                addReason={addReason}
                                deleteReason={deleteReason}
                                key={reason}
                            />
                        ))}
                    </div>
                </div>
            ))}
            <TextArea
                className={styles.message}
                value={message}
                placeholder={i18n('feedback', 'message-placeholder')}
                size="lg"
                onChange={onMessageChange}
            />
        </div>
    );
}
